import { FaHandshake } from "react-icons/fa6";
import { Col, Container, Row } from "reactstrap";
import DashboardCRatioCard from "../../components/cards/DashboardCRatioCard";
import DashboardCustomerCard from "../../components/cards/DashboardCustomerCard";
import DashboardDisplayCard from "../../components/cards/DashboardDisplayCard";
import MyPlaceCard from "../../components/cards/MyPlaceCard";
import Header from "../../components/globals/Header";
import FilterBasedSearch from "../../components/inputs/FilterBasedSearch";
import UserHomeMap from "../../components/page-sections/UserHomeMap";
import { useGetPlacesHooks } from "../../hooks/useGetPlacesHooks";
import { useTranslation } from "../../languages";
import { useEventHooks } from "../../hooks/useEventHooks";
import { useDeviceLocation } from "../../hooks/utilityHooks";
import { useMemo, useState } from "react";
const ContributerDashboard = ({onLogout}) => {
  const {
    //all places data
    placesData, placeId, setPlaceId, place_stats_redux, time, setTime
  } = useGetPlacesHooks();


  const {allMyEvents}=useEventHooks();
  const {location}=useDeviceLocation(true);
  const { t } = useTranslation();
  const [mapCenter,setMapCenter]=useState({lat:0,lng:0});

console.log("ALL-MY-EVENTS----",allMyEvents);
const normalEvents=useMemo(()=>{
  return [...allMyEvents]?.filter((e)=>!e?.isSpecial)?.map((i)=>({...(i??{}),lat:i?.location?.coordinates?.lat,
  lng:i?.location?.coordinates?.lng
  }))
},[allMyEvents])

  return (
    <div>
      <Container fluid>
        <Header title={t("analytics")} onLogout={onLogout} />
        {/* <FilterBasedSearch /> */}
        <div className="d-flex justify-content-end align-items-center w-full">
          <div className="d-flex gap-2">
            <select className="form-select mt-3" value={time} onChange={(e) => setTime(e.target.value)}>
              <option value="">Select Time</option>
              <option value='today'>Today</option>
              <option value='month'>Month</option>
              <option value='year'>Year</option>
            </select>
            <select className="form-select mt-3" value={placeId} onChange={(e) => setPlaceId(e.target.value)}>
              <option value="">Select Place</option>
              {placesData?.map((place) => (
                <option key={place?._id} value={place?._id}>
                  {place.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <Row className="g-3 mt-3">
          <Col md={6} xl={3}>
            <DashboardDisplayCard
              showIncreaseIcon={true}
              title={t("profileVisitors")}
              subtitle={place_stats_redux?.totalViews?.length ?? 0}
            />
          </Col>
          <Col md={6} xl={3}>
            <DashboardDisplayCard
              title={t("customerReviews")}
              subtitle={place_stats_redux?.reviewAverage ?? 0}
            />
          </Col>
          <Col md={6} xl={3}>
            <DashboardDisplayCard
              showIncreaseIcon={true}
              title={t("customerRatio")}
              subtitle={`${place_stats_redux?.customerRatio ?? 0}%`}
            />
          </Col>
          <Col md={6} xl={3}>
            <DashboardDisplayCard
              title={t("reservations")}
              subtitle={`${place_stats_redux?.totalReservations ?? 0}`}
              icon={<FaHandshake size={40} />}
            />
          </Col>
        </Row>
        <Row className="gx-xl-5 gx-lg-3 mt-4 gy-2">
          <Col md={12} lg={7}>
            <DashboardCustomerCard total={180} />
          </Col>
          <Col md={12} lg={5}>
            <DashboardCRatioCard />
          </Col>
        </Row>
        <h4 className="f-7 color-primary-black-2 my-4">{t("myPlaces")}</h4>
       
        {/* replace below with map */}
        <UserHomeMap 
        mapCenter={mapCenter}
        setMapCenter={setMapCenter}
        normalEvents={normalEvents}

        placesData={placesData}
        userLocation={location}
        />
      </Container>
    </div>
  );
};
export default ContributerDashboard;
